import { getBreedRoutesFromRoutes } from '../breeds/getBreedRoutesFromRoutes';

import { reviewsData } from './CustomerReviews/reviewsData';

import type { CreateBreedSchemaArgs } from './createBreedSchema';
import type { BreedDocument } from './types';
import type { ClientRoute } from '../../static-context';

export interface PrepareBreedSchemaDataArgs {
  document: BreedDocument;
  relatedBreedLinks: ClientRoute[];
  baseUrl: string;
}

export function prepareBreedSchemaData({
  document,
  relatedBreedLinks,
  baseUrl,
}: PrepareBreedSchemaDataArgs): CreateBreedSchemaArgs {
  const breed = document.data.title;
  const slug = document.uid ?? document.id;
  const breedPlural = document.data.plural_name ?? `${breed}s`;

  const relatedBreeds = getBreedRoutesFromRoutes(relatedBreedLinks);

  const reviews = reviewsData.map(({ author, quote }) => ({
    author,
    body: quote,
  }));

  return {
    breed,
    breedPlural,
    slug,
    shortDescription: document.data.short_description ?? '',
    wikipediaUrl: document.data.wikipedia_url ?? '',
    healthIssue1: document.data.health_issue_1 ?? '',
    healthIssue2: document.data.health_issue_2 ?? '',
    reviews,
    relatedBreeds,
    baseUrl,
  };
}
